import { AfterViewInit, Directive, ElementRef, HostBinding, OnDestroy } from "@angular/core";
import { PlatformService, WindowRef } from "@obg/ngx.global.evo";

@Directive({
	selector: "[obgMatTabsScroll]",
})
export class ObgMatTabsScrollDirective implements AfterViewInit, OnDestroy {
	@HostBinding("class.obg-mat-tabs-scroll") hostCssClass = true;

	private eventListeners = new Map<string, EventListener>();

	constructor(
		private platformService: PlatformService,
		private elementRef: ElementRef,
		private windowRef: WindowRef
	) {}

	ngAfterViewInit() {
		if (this.platformService.isServer) {
			return;
		}
		this.addEventListeners();
	}

	ngOnDestroy() {
		const matTabList = this.elementRef.nativeElement.querySelector(".mat-tab-list");

		this.eventListeners.forEach((listener, event) => matTabList.removeEventListener(event, listener));
		this.eventListeners.clear();
	}

	private addEventListeners() {
		let animationFrameId: number;
		const disableTransitionClass = "disable-transition";
		const matTabList = this.elementRef.nativeElement.querySelector(".mat-tab-list");
		let startX = 0;
		let startScroll = 0;

		this.eventListeners.set("touchstart", (evt: TouchEvent) => {
			startX = evt.touches[0].clientX;
			startScroll = -this.getTranslateX(matTabList.style.transform);
			matTabList.classList.add(disableTransitionClass);
		});
		this.eventListeners.set("touchmove", (evt: TouchEvent) => {
			if (matTabList.parentElement == null) {
				return;
			}

			const animationFrameCallback = () => {
				const touch = evt.changedTouches[0];
				const maxPixelsToBeScrolled = matTabList.scrollWidth - matTabList.parentElement.clientWidth;
				const scrollablePixels = Math.min(startScroll + (startX - touch.clientX), maxPixelsToBeScrolled);
				matTabList.style.transform = `translateX(-${scrollablePixels}px)`;
			};

			if (this.windowRef.native.requestAnimationFrame) {
				this.cancelAnimationFrame(animationFrameId);
				animationFrameId = this.windowRef.native.requestAnimationFrame(animationFrameCallback);
			} else {
				animationFrameCallback();
			}
		});
		this.eventListeners.set("touchend", () => {
			matTabList.classList.remove(disableTransitionClass);
			this.cancelAnimationFrame(animationFrameId);
		});

		this.eventListeners.forEach((listener, event) => matTabList.addEventListener(event, listener));
	}

	private getTranslateX(transformValue: string | null): number {
		if (transformValue == null) {
			return 0;
		}

		const translateXRegex = /\.*translateX\((.*)px\)/g;
		const translateX = translateXRegex.exec(transformValue);
		if (translateX) {
			return Number(translateX[1]);
		}
		return 0;
	}

	private cancelAnimationFrame(animationFrameId: number) {
		if (window.cancelAnimationFrame !== undefined && animationFrameId) {
			this.windowRef.native.cancelAnimationFrame(animationFrameId);
		}
	}
}
